import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Checks if the current user has the 'admin' role in user_roles table.
 * Returns { isAdmin, isLoading }.
 */
export function useIsAdmin() {
  const query = useQuery({
    queryKey: ["is-admin"],
    queryFn: async (): Promise<boolean> => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      const { data, error } = await supabase.rpc("has_role", {
        _user_id: user.id,
        _role: "admin",
      });

      if (error) return false;
      return !!data;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    retry: 1,
  });

  return {
    isAdmin: query.data ?? false,
    isLoading: query.isLoading,
  };
}
